export const GET_REPORT_DATA_PENDING = "GET_REPORT_DATA_PENDING";
export const GET_REPORT_DATA_SUCCESS = "GET_REPORT_DATA_SUCCESS";
export const GET_REPORT_DATA_ERROR = "GET_REPORT_DATA_ERROR";
export const SET_INITIAL_STATE = "SET_INITIAL_STATE";
export const SET_REPORT_DATA = "SET_REPORT_DATA";
